import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { isAiDataEmpty } from '../use';
import { subscriptionManager, FeatureAddOn } from '@/_core/utils/features';
import { currentUserWsRoles } from '@/_core/utils/roles';
import { confirm } from '@/_core/app-components/use';
import { SetAiDialogIsOpen } from './setAiDialogIsOpen';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SetCollectUserGoalsDialogIsOpen extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetCollectUserGoalsDialogIsOpen';

    public constructor(public isOpen: boolean, public activityOrder: number | null = null, public scope: string = null) {
        super(SetCollectUserGoalsDialogIsOpen.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const middleware = async (state: StorymapState, action: SetCollectUserGoalsDialogIsOpen): Promise<boolean> => {
    const hasAiFeatureAddon = subscriptionManager.hasFeatureAddOn(FeatureAddOn.AI);

    if (action.isOpen === true && (isAiDataEmpty.value || !hasAiFeatureAddon)) {
        if (!currentUserWsRoles.isSubscriptionAdmin && !hasAiFeatureAddon) {
            confirm.show({
                title: 'AI feature is turned off on this workspace',
                message: 'Please contact your subscription admin to enable StoriesOnBoard AI Assistant.',
                acceptBtnText: 'Ok',
                isHideCancelBtn: true,
            });
            return false;
        }
        dispatch(
            new SetAiDialogIsOpen(true, {
                onDialogClose: () => {
                    dispatch(new SetCollectUserGoalsDialogIsOpen(action.isOpen, action.activityOrder, action.scope));
                },
            })
        );
        return false;
    }

    return true;
};

const reducer = (state: StorymapState, action: SetCollectUserGoalsDialogIsOpen): void => {
    state.collectUserGoalsDialogState.activityOrder = action.activityOrder;
    state.collectUserGoalsDialogState.scope = action.scope;
    state.collectUserGoalsDialogState.isOpen = action.isOpen;
};

//@ts-ignore
registerMiddleware(SetCollectUserGoalsDialogIsOpen.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetCollectUserGoalsDialogIsOpen.ACTION_TYPE, reducer);
